// Footer.js
import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";
import { Link } from 'react-router-dom';

import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-logo-section">
          <img
            className="main-logo"
            src={require("../images/apavit-logo.png")}
            alt="Distintivo Mincetur"
          />
          <Link to="/certificadoDircetur">
  <img
    className="main-logo dircetur-logo"
    src={require("../images/dircetur-logo.png")}
    alt="Distintivo Mincetur"
  />
</Link>
        </div>
        <a
          href="https://wa.me/51941950860"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-contact"
        >
          <div className="footer-contact-text">
            Descubre tu próxima aventura con nosotros ¡Cotiza aquí!
          </div>
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>

      <div className="footer-middle">
        <div className="footer-content">
          <div className="footer-logo-principal">
            <img
              className="main-logo"
              src={require("../images/images-logo/imagotipoTarapotoBlanco.png")}
              alt="Multiback Logo"
            />
          </div>
          <div className="footer-section">
            <h4>Métodos de Pago:</h4>
            <div className="footer-advertencia">
              Puedes pagar por estos medios <br></br>después de cotizar
            </div>
            <ul className="payment-icons">
              <li>
                <i className="fas fa-money-bill-wave"></i> Efectivo
              </li>
              <li>
                <i className="fas fa-university"></i> Transferencia bancaria
              </li>
              <li>
                <i className="fas fa-credit-card"></i> Tarjetas de crédito
                <br />
                <i className="fab fa-cc-visa card-icon"></i>
                <i className="fab fa-cc-mastercard card-icon"></i>
                <i className="fab fa-cc-amex card-icon"></i>
              </li>
              <li>
                <i className="fas fa-mobile-alt"></i> Aplicaciones de pago:
                Yape, Plin
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="creditos">
          <ul>
            <li>
              <a href="contacto">Contacto</a>
            </li>
            <li>
              <a href="/nosotros">Nosotros</a>
            </li>
            <li>
              <a href="/politicas">Políticas</a>
            </li>
            <li>
              <a href="/terminos">Términos y Condiciones</a>
            </li>
            <li>
              <a href="/libroreclamaciones">Libro de Reclamaciones</a>
            </li>
            <li>
              <a href="/proteccionMenores">Protección de Menores</a>
            </li>
          </ul>
          <p>&copy; Todos los Derechos Reservados | 2024</p>
        </div>
        <ul className="redesfoo">
          <li>
            <a
              href="https://www.facebook.com/profile.php?id=61567164249377"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/fadatours/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </li>
        </ul>
        <p className="credito">
          Diseñado por{" "}
          <a href="http://www.multiback.com/" target="_blank" rel="noreferrer">
            Multiback
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
